import { Component, Input } from '@angular/core';
@Component({
  selector: 'payarc-inline-alert',
  template: `
    <div class="pa-alert" [ngClass]="'pa-alert--' + variant">
      <span class="pa-alert__dot"></span>
      <div class="pa-alert__body"><ng-content></ng-content></div>
    </div>`,
  styleUrls: ['./payarc-inline-alert.component.css'],
  standalone: false
})
export class PayarcInlineAlertComponent {
  @Input() variant: 'info' | 'good' | 'warn' | 'bad' = 'info';
}
